import React from "react";
import styles from "./PageNotFound.module.scss";

const PageNotFound: React.FC = () => {

    return (
        <div className={styles.pageNotFound}>
            404 ERROR <br/>
            Page not found
        </div>
    );
};

export default PageNotFound;
